// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationButton_root__3XsAu","icon":"NavigationButton_icon__1kfJI","selected":"NavigationButton_selected__2OMj6"};